import { ChangeEvent, useState } from 'react';
import { toast } from 'react-toastify';

import {
  Button,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { Grid2 as Grid } from '@mui/material';

import {
  InputLineNumber,
  ModalActionButtons,
  ModalBox,
  ModalContent,
  ModalHeader,
} from './FilterRegistroModal.styles';

const FilterRegistroModal = ({
  codigoRegistro,
  open,
  onClose,
  searchButtonAction,
  clearFilterButtonAction,
}: {
  codigoRegistro: string;
  open: boolean;
  onClose: () => void;
  searchButtonAction: (
    lineNumber: number | null,
    codigoRegistro: string,
  ) => void;
  clearFilterButtonAction: () => void;
}) => {
  const LineFilterOptions = {
    somenteInseridas: 'inseridas',
    linhasTxt: 'txt',
  };

  const [filterOption, setFilterOption] = useState(LineFilterOptions.linhasTxt);
  const [lineNumber, setLineNumber] = useState<number | null>(null);
  const [lineNumberFilter, setLineNumberFilter] = useState<number | null>(null);

  const handleFilterOptionChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;
    setFilterOption(value);
    setLineNumber(0);
  };

  const handleLineNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value =
      event.target.value === ''
        ? null
        : Number(event.target.value.replace(/[^0-9]/g, ''));
    setLineNumberFilter(value);
    setLineNumber(value);
  };

  const handleClearFilterButtonAction = () => {
    setFilterOption('txt');
    setLineNumberFilter(null);
    setLineNumber(null);
    clearFilterButtonAction();
    onClose();
  };

  const handleSearchButtonAction = () => {
    if (
      filterOption === LineFilterOptions.linhasTxt &&
      lineNumberFilter === null
    ) {
      toast.warning('Informe um valor de linha válido.');
      return;
    }
    searchButtonAction(lineNumber, codigoRegistro);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox>
        <ModalHeader>
          <Typography variant="h6" component="h2">
            Filtrar Registro - {codigoRegistro}
          </Typography>
        </ModalHeader>

        <ModalContent>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={filterOption}
              onChange={handleFilterOptionChange}
            >
              <FormControlLabel
                value={LineFilterOptions.somenteInseridas}
                control={<Radio />}
                label="Linhas inseridas"
              />
              <FormControlLabel
                value={LineFilterOptions.linhasTxt}
                control={<Radio />}
                label="Linhas TXT"
              />
            </RadioGroup>
          </FormControl>
          <InputLineNumber
            fullWidth
            label=""
            id="numeroLinha"
            name="numeroLinha"
            onChange={handleLineNumberChange}
            placeholder="Nº linha"
            disabled={filterOption !== 'txt'}
            value={lineNumberFilter ?? ''}
            type="number"
          />
        </ModalContent>

        <ModalActionButtons
          container
          spacing={2}
          justifyContent="flex-end"
          mt={2}
        >
          <Grid>
            <Button
              data-testid="clear-filter-button"
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => handleClearFilterButtonAction()}
            >
              Limpar
            </Button>
          </Grid>
          <Grid>
            <Button
              data-testid="search-button"
              variant="contained"
              color="primary"
              size="small"
              onClick={() => handleSearchButtonAction()}
            >
              Buscar
            </Button>
          </Grid>
        </ModalActionButtons>
      </ModalBox>
    </Modal>
  );
};

export default FilterRegistroModal;
